import React from "react";
import PropTypes from "prop-types";

import { WAGE_MIN, WAGE_MAX, WAGE_DEFAULT } from "lib/config";
import { questionProps } from "lib/propTypes";

export default class PrefWageQuestion extends React.PureComponent {
    static propTypes = {
        ...questionProps,
        handleAnswer: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.handleAnswer({
            preSubmit: this.preSubmit,
            questionID: this.props.id,
            response: WAGE_DEFAULT,
        });
    }

    onBlur = (event) => {
        const { target } = event;
        target.value = this.getWage(target.value);
    };

    onChange = (event) => {
        const { target } = event;
        const value = Number(target.value);

        this.props.handleAnswer({
            preSubmit: this.preSubmit,
            questionID: this.props.id,
            response: value,
        });
    };

    getWage(input) {
        // Ensure the value fits in our min/max values
        return Math.round(Math.min(WAGE_MAX, Math.max(WAGE_MIN, input)));
    }

    preSubmit = (answer) => {
        const response = this.getWage(answer.response);

        return new Promise((resolve) => {
            resolve({
                ...answer,
                response,
            });
        });
    };

    render() {
        return (
            <div>
                <label className="questions__title">{this.props.question}</label>
                <div className="questions__pref-wage-container wage-pref-input">
                    <span className="wage-input-prefix">$</span>
                    <span className="wage-input-suffix">/hour</span>
                    <input
                        autoComplete="off"
                        type="number"
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        min={WAGE_MIN}
                        max={WAGE_MAX}
                        step="1"
                        defaultValue={WAGE_DEFAULT}
                    />
                </div>
            </div>
        );
    }
}
